import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";

export const save = (payload) => async (dispatch) => {
  try {
    const res = await api.post("/companies", payload);
    return res.data;
  } catch (error) {
    dispatch({
      type: LOGOUT
    });
  }
};

export const search = ({ page = 0, size = 10, order = "Person.updatedAt", direction = "desc", search = null }) => async (dispatch) => {
  try {
    const res = await api.get(`/companies/p/${page}/s/${size}/o/${order}/${direction}/${search || ""}`);
    return res.data;
  } catch (err) {
    dispatch({
      type: LOGOUT,
    });
  }
};

export const get = ({ uuid }) => async (dispatch) => {
  try {
    const res = isGuid(uuid ?? null) ? await api.get(`/companies/i/${uuid}`) : { data: { success: false } };
    return res.data;
  } catch (err) {
    dispatch({
      type: LOGOUT
    });
  }
};

export const people = ({ companyUuid, page = 0, size = 10, order = "lastName", direction = "asc", search = null }) => async (dispatch) => {
  try {
    const res = await api.get(`/companies/i/${companyUuid}/people/p/${page}/s/${size}/o/${order}/${direction}/${search || ""}`);
    return res.data;
  } catch (err) {
    dispatch({
      type: LOGOUT,
    });
  }
};

export const peopleBatch = ({ companyUuid, items }) => async (dispatch) => {
  try {
    const res = await api.post("/companies/people/batch", { companyUuid, items });
    return res.data;
  } catch (err) {
    dispatch({
      type: LOGOUT,
    });
  }
};
